module.exports = __webpack_public_path__ + "img/0f0cf231ba01a40ac8e107e3b481cb4f.png";